import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, ResponsiveContainer } from 'recharts';

interface ChartItem {
  name: string;
  code: string;
  qtddoc: string;
}

export const RankEmployesWithMoreMedicalCertificate = ({ data }: { data: ChartItem[] }) => {
  const chartData = data.map(item => {
    const fullLabel = `${item.code} - ${item.name}`;
    return {
      ...item,
      shortName: fullLabel.length > 25 ? fullLabel.slice(0, 25) + '…' : fullLabel,
      qtddoc: Number(item.qtddoc),
    };
  });

  const maxCount = Math.max(...chartData.map(item => item.qtddoc));
  const controllerHeight = Math.max(chartData.length * 50 + 40, 100);

  return (
    <div style={{ width: '100%'}}>
      <p style={{ color: '#54586e', fontSize: 20, fontWeight: 700, margin: '0 0 4px 0', padding: '1px' }}>
        Os 10 colaboradores com mais documentos
      </p>
      <span style={{ color: '#8d95a0', fontSize: 13, fontWeight: 400 }}>
        Identificar colaboradores com maior quantidade de atestados.
      </span>

    <ResponsiveContainer width="100%" height={controllerHeight}>
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 20, right: 60, bottom: 10, left: 10 }}
        >
          <XAxis
            type="number"
            domain={[0, maxCount + 1]}
            allowDecimals={false}
            height={50}
            label={{value: 'Documentos', position: 'insideBottomRight', fill: '#413ea0', fontSize: 16, fontWeight: 500}}
          />
          
          <YAxis
            type="category"
            dataKey="shortName"
            width={160}
            tick={{ fontSize: 13, fill: '#4a4a4a', fontWeight: 500 }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            content={({ active, payload, label }) => {
              if (!active || !payload?.length) return null;
              const item = payload[0].payload;
              return (
                <div style={{
                  background: '#fff',
                  border: '1px solid #ccc',
                  borderRadius: 6,
                  padding: '8px 12px',
                  fontSize: 13,
                  color: '#2563eb'
                }}>
                  <p style={{ margin: 0, fontWeight: 600 }}>Colaborador: {label}</p>
                  <p style={{ margin: '4px 0 0' }}>Código: {item.code}</p>
                  <p style={{ margin: '4px 0 0' }}>Documentos: {item.qtddoc}</p>
                </div>
              );
            }}
          />
          <Bar
            dataKey="qtddoc"
            name="Documentos"
            fill="#413ea0"
            radius={[0, 6, 6, 0]}
            barSize={24}
          >
            <LabelList
              dataKey="qtddoc"
              position="right"
              style={{ fontSize: 13, fill: '#4a4a4a', fontWeight: 600 }}
            />  
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};